import Vue from 'vue'
import VueRouter, { NavigationGuardNext, Route, RouteConfig } from 'vue-router'

import HttpStatusCode from 'http-status-codes'

import DefaultLayout from '@/layouts/default/DefaultLayout'
import LoginPage from '@/modules/authentication/login/LoginPage'
import ErrorPage from '@/modules/global/error/ErrorPage'
import InscriptionLieuExamenPage from '@/modules/inscription-lieu-examen/InscriptionLieuExamenPage'
import OverviewInscriptionOffreCours from '@/modules/inscription-lieu-examen/overview/OverviewInscriptionOffreCours'
import FormInscriptionOffreCours from '@/modules/inscription-lieu-examen/form/FormInscriptionOffreCours'
import GestionFicheRepondantPage from '@/modules/fiche-repondant/GestionFicheRepondantPage'
import OverviewFicheRepondant from '@/modules/fiche-repondant/overview/OverviewFicheRepondant'
import FicheRepondantCreate from '@/modules/fiche-repondant/create/FicheRepondantCreate'
import FicheRepondantUpdate from '@/modules/fiche-repondant/update/FicheRepondantUpdate'

import ROUTES from './ROUTES'
import Localization from '@/localization'
import RouterLocalizationHelper, { 
  generateLocalizedRouteName, 
  extractLocalizedRouteParameters, 
  ILocalizedRouteParameters, 
  LOCAL_STORAGE_LOGIN_REMEMBERED_ROUTE
} from '@/router/helpers'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '',
    name: ROUTES.DEFAULT,
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: ROUTES.INSCRIPTION_ETUDIANT,
        component: InscriptionLieuExamenPage,
        children: [
          {
            path: '',
            name: ROUTES.INSCRIPTION_ETUDIANT_APERCU,
            component: OverviewInscriptionOffreCours
          },
          {
            path: '',
            name: ROUTES.INSCRIPTION_ETUDIANT_FORMULAIRE,
            component: FormInscriptionOffreCours
          }
        ]
      },
      {
        path: '',
        name: ROUTES.FICHE_REPONDANT_GESTION,
        component: GestionFicheRepondantPage,
        children: [
          {
            path: '',
            name: ROUTES.FICHE_REPONDANT_OVERVIEW,
            component: OverviewFicheRepondant
          },
          {
            path: '',
            name: ROUTES.FICHE_REPONDANT_CREATE,
            component: FicheRepondantCreate
          },
          {
            path: '',
            name: ROUTES.FICHE_REPONDANT_UPDATE,
            component: FicheRepondantUpdate
          }
        ]
      },
      {
        path: '',
        name: ROUTES.LOGIN,
        component: LoginPage
      },
      {
        path: '',
        name: ROUTES.ERROR,
        component: ErrorPage
      }
    ]
  },
  {
    path: '*',
    name: ROUTES.WILDCARD
  }
]

const router = new VueRouter({
  routes: RouterLocalizationHelper(routes)
})

router.beforeEach((to: Route, from: Route, next: NavigationGuardNext) => {
  const routeParameters: ILocalizedRouteParameters = extractLocalizedRouteParameters(to.name as string)

  if (routeParameters.name === ROUTES.WILDCARD) {
    return next({
      name: generateLocalizedRouteName({
        name: ROUTES.ERROR,
        locale: Localization.CURRENT_LOCALE
      }),
      params: {
        status: HttpStatusCode.NOT_FOUND.toString()
      }
    })
  } else if (routeParameters.name === ROUTES.DEFAULT) {
    return next({
      name: generateLocalizedRouteName({
        name: ROUTES.LOGIN,
        locale: Localization.CURRENT_LOCALE
      })
    })
  } else if (
    routeParameters.name === ROUTES.INSCRIPTION_ETUDIANT &&
    !to.params.token
  ) {
    return next({
      name: generateLocalizedRouteName({
        name: ROUTES.ERROR,
        locale: Localization.CURRENT_LOCALE
      })
    })
  } else if (routeParameters.name === ROUTES.LOGIN && from && from.name) {
    const fromRouteParameters: ILocalizedRouteParameters = extractLocalizedRouteParameters(from.name)
    localStorage.setItem(LOCAL_STORAGE_LOGIN_REMEMBERED_ROUTE, from.fullPath)
  }

  if (routeParameters.locale !== Localization.CURRENT_LOCALE) {
    return next({
      name: generateLocalizedRouteName({
        name: routeParameters.name,
        locale: Localization.CURRENT_LOCALE
      }),
      params: to.params,
      query: to.query
    })
  }

  return next()
})

export default router
